import { render } from "./Transformation.vue?vue&type=template&id=06dbbd91&scoped=true"
import script from "./Transformation.vue?vue&type=script&lang=js"
export * from "./Transformation.vue?vue&type=script&lang=js"

import "./Transformation.vue?vue&type=style&index=0&id=06dbbd91&lang=scss&scoped=true"

import exportComponent from "/Users/josue/Documents/projects/wwv/dapp/werewolfvalley/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06dbbd91"]])

export default __exports__